import React, { useState, createContext, useContext } from 'react';
import { cn } from '../../lib/utils';

const TabsContext = createContext(null);

export function Tabs({ defaultValue, className, children }) {
    const [activeTab, setActiveTab] = useState(defaultValue);

    return (
        <TabsContext.Provider value={{ activeTab, setActiveTab }}>
            <div className={cn("w-full", className)}>
                {children}
            </div>
        </TabsContext.Provider>
    );
}

export function TabsList({ className, children, ...props }) {
    return (
        <div className={cn("inline-flex h-auto items-center justify-center rounded-lg bg-slate-100 p-1 text-slate-500 flex-wrap overflow-x-auto max-w-full", className)} {...props}>
            {children}
        </div>
    );
}

export function TabsTrigger({ value, className, children, ...props }) {
    const { activeTab, setActiveTab } = useContext(TabsContext);
    const isActive = activeTab === value;

    return (
        <button
            type="button"
            data-state={isActive ? 'active' : 'inactive'}
            onClick={() => setActiveTab(value)}
            className={cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2",
                isActive ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-900 hover:bg-slate-50",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}

export function TabsContent({ value, className, children, ...props }) {
    const { activeTab } = useContext(TabsContext);
    if (activeTab !== value) return null;

    return (
        <div className={cn("mt-4 ring-offset-white focus-visible:outline-none", className)} {...props}>
            {children}
        </div>
    );
}
